export default __webpack_public_path__ + "static/media/scroll-icon.62bd1fdf.svg";